import { AccountInfo, IdTokenClaims } from "@azure/msal-browser";

export interface Claims {
  roles: string;
}

export enum UserRole {
  CLIENT_ADMIN = "clientadmin", 
  ADMIN = "admin"
}

export function decodeJwt(claims: IdTokenClaims): Claims | null {
  return {
    roles: claims["roles"] as unknown as string
  };
}

export function getUserRole(account: AccountInfo | null): UserRole | null {
    if (!account || !account.idToken) {
      console.log(`Account is malformed or doesn't have token`)
      return null
    }

    if (account?.idTokenClaims == undefined) {
      console.log(`Account has no valid claims`)
      return null;
    }

    const claims = decodeJwt(account?.idTokenClaims);
    if (claims == null) {
      console.log(`couldn't decode jwt: ${account.idToken}`)
      return null
    }

    let roles = claims?.roles?.split(',').map((g: string) => g.trim());
    if (roles?.length == 0) {
        console.log(`no user roles found in payload: ${claims.roles}`)
        return null
    }

    return extractUserRole(roles)
}

export const extractUserRole = (roles: string[]): UserRole | null => {
    let admin = roles?.some(g => g.trim().toLowerCase() === UserRole.ADMIN.toString());
    if (admin) {
      return UserRole.ADMIN
    }

    let clientAdmin = roles?.some(g => g.trim().toLowerCase() === UserRole.CLIENT_ADMIN.toString());
    if (clientAdmin) {
      return UserRole.CLIENT_ADMIN
    }

    return null
}